import { render } from "./CenikDivider.vue?vue&type=template&id=c26525e2&scoped=true"
const script = {}

import "./CenikDivider.vue?vue&type=style&index=0&id=c26525e2&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c26525e2"]])

export default __exports__